/**
 * API接口统一出口
 */

// 导入各模块API
import * as registration from './registration'
import * as submission from './submission'
import * as speaker from './speaker'

// 统一导出
export default {
  registration,
  submission,
  speaker
}